import ICO from './modules/core.js';
import { params, vars } from './modules/variables.js';
import { extendFormElements } from './modules/formElements.js';
import { extendTransitions } from './modules/transitions.js';
import { extendVCard } from './modules/vcard.js';

ICO.params = params;
ICO.vars = vars;

extendFormElements(ICO);
extendTransitions(ICO);
extendVCard(ICO);

window.ICO = ICO;
export default ICO;
